import '@/styles/globals.css'
import '@/styles/override.authing.css'
import { Toaster } from 'react-hot-toast'
// import '@forchange/panda-loading/dist/loading.css'
import Head from 'next/head'
import 'core-js/es/object/assign'
import 'core-js/es/object/entries'
import 'core-js/es/array/includes'
import 'core-js/es/array/iterator'
import 'core-js/es/array/find'
import 'core-js/es/array/from'
import 'core-js/es/promise'
import 'core-js/es/promise/finally'
import 'core-js/es/symbol'
import 'core-js/es/global-this'
import { useMount } from 'ahooks'
import App, { AppProps } from 'next/app'
import { AuthingWrapper } from '@/components/authingWrapper'
import { getNamespaceAndLocationByServer } from '@/utils'
import { getAuthingConfig } from '@/utils/getAuthingConfig.server'

function Entry({ Component, pageProps, __SERVER_VAR__, namespace }: AppProps & Record<any, any>) {
  useMount(async () => {
    const forchangeInfo = await (await import('@forchange/info')).default
    forchangeInfo({
      project: 'CLEWORD_AUTH',
      author: null,
      version: process.env.NEXT_PUBLIC_COMMIT_VERSION,
      env: process.env.NEXT_PUBLIC_APP_ENV
    })
  })

  return (
    <>
      <Head>
        <title>课灵小馆</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
        />
      </Head>
      <AuthingWrapper __SERVER_VAR__={__SERVER_VAR__} namespace={namespace}>
        {(tenant) => <Component {...pageProps} tenant={tenant} />}
      </AuthingWrapper>
      <Toaster />
    </>
  )
}

Entry.getInitialProps = async(context) => {
  const ctx = await App.getInitialProps(context)
  const [namespace, _] = getNamespaceAndLocationByServer(context.ctx)

  const __SERVER_VAR__ = getAuthingConfig(namespace)

  return {
    ...ctx,
    __SERVER_VAR__,
    namespace
  }
}

export default Entry
